var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuctionicLogoRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 38.54 37.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.57 25.04l-4.67 4.17 -5.09 -4.54 4.67 -4.17 5.09 4.54zm-2.23 -4.42l5.09 4.54 4.67 -4.17 5.09 4.54 3.77 -3.36 -4.5 -8.14 -4.86 -1.68 -9.26 8.27zm12.35 5.1l-4.68 4.17 -1.55 1.38 -1.42 1.27 -4.37 -3.9 2.97 -2.65 1.88 1.68 4.68 -4.17 2.49 2.22zm6.2 5.53l-5.37 4.8 -5.09 -4.54 5.37 -4.8 5.09 4.54zm3.66 6.5l-8.68 0 4.34 -3.87 4.34 3.87zm-18.69 0l-0.08 -0.07 4.67 -4.17 4.76 4.24 -9.35 0zm-0.5 -21.34l-4.12 3.67 -4.44 -3.98 2.69 -4.96 5.88 5.26zm-6.98 3.1l-4.67 4.17 -0.68 -0.62 3.05 -5.62 2.31 2.07zm0.39 10.72l-8.43 7.52 -2.28 0 -2.04 -1.74 6.28 -11.58 6.48 5.79zm8.26 4.35l-3.55 3.17 -4.25 0 -3.34 -2.98 5.68 -5.07 5.46 4.87zm-0.48 -19.23l-6.3 -5.61 3.26 -6.01 5.2 -3.72 4.99 8.94 -7.15 6.4z",
    fill: "#ff002b",
    className: "color000 svgShape"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuctionicLogoRed);
export default __webpack_public_path__ + "static/media/auctionic_logo_red.8a52ff1d542a5ce9620a4d7b0e3c71da.svg";
export { ForwardRef as ReactComponent };